module.exports = __webpack_public_path__ + "img/logo.e1096f3b.svg";